import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentCollectionRequest } from '../../model/payment/PaymentCollectionRequest';
import {ConfigService} from '../../service/config.service';

@Component({
  selector: 'app-payment-mode-net-banking',
  templateUrl: './payment-mode-net-banking.component.html',
  styleUrls: ['./payment-mode-net-banking.component.scss']
})
export class PaymentModeNetBankingComponent implements OnInit {

  public netBankingForm: FormGroup;
  public bankList: string[];
  public payUConvenienceFeeGSTPercentage: number;

  @Input()
  paymentRequest: PaymentCollectionRequest;
  @Output()
  isFormInstanceCreated: EventEmitter<any> = new EventEmitter<any>();
  constructor(private formBuilder: FormBuilder, private configService: ConfigService) { }

  async ngOnInit(): Promise<void> {
    this.bankList = this.configService.getPaymentIssuerCodesForNetBanking();
    this.getpayUConvenienceFee();
    await this.initializeForm();
  }

  async initializeForm() {
    this.netBankingForm = this.formBuilder.group({
      bankName: this.formBuilder.control(null, [Validators.required]),
    })
    this.isFormInstanceCreated.emit(this.netBankingForm);
  }

  get netBankingControls() {
    return this.netBankingForm.controls;
  }

  public getpayUConvenienceFee() {
    const payUConvenienceFeeOfNetBanking =  this.configService.getPayUConvenienceFeeOfNetBanking();
    this.payUConvenienceFeeGSTPercentage =  this.configService.getPayUConvenienceFeeGSTPercentage();
    return payUConvenienceFeeOfNetBanking * (1 + this.payUConvenienceFeeGSTPercentage / 100);
  }
}
